import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { ResourcesBannerModule } from '../shared/modules/resources-banner/resources-banner.module';
import { BrowseByTopicComponent } from './browse-by-topic/browse-by-topic.component';
import { DisplayImgComponent } from './display-img/display-img.component';
import { HealthcareProviderInformationComponent } from './healthcare-provider-information/healthcare-provider-information.component';
import { PatientEducationComponent } from './patient-education/patient-education.component';

@NgModule({
  declarations: [
    PatientEducationComponent,
    HealthcareProviderInformationComponent,
    BrowseByTopicComponent,
    DisplayImgComponent,
  ],
  imports: [
    CommonModule,
    ResourcesBannerModule,
    FluDashboardBannerModule,
    NgSelectModule,
    FormsModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SanofiPatientEducationHorizontalComponent: {
          component: () =>
            import('./patient-education/patient-education.component').then(
              (m) => m.PatientEducationComponent
            ),
          guards: [AuthGuard],
        },
        SanofiPatientEducationVerticalComponent: {
          component: () =>
            import('./browse-by-topic/browse-by-topic.component').then(
              (m) => m.BrowseByTopicComponent
            ),
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class ToolsAndResourcesModule {}
